/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useState } from 'react';

const messengerContext = createContext();

export default messengerContext;
